  document.addEventListener('DOMContentLoaded', () => {
    window.deliveryPincodeSLA = {};
    window.currentVariantAvailable = true;
    window.lastCheckedPincode = null;

    // Parsed once and reused — #product-json is never swapped client-side on this theme.
    let cachedProductJson = null;

    // Store dispatches by 12:00 PM IST; orders placed after cutoff push the delivery estimate out by a day.
    const DISPATCH_CUTOFF_HOUR = 12;
    const IST_OFFSET_MINUTES = 5.5 * 60;

    fetch(document.querySelector('.check-delivery-container').dataset.deliverySlaJson)
      .then((res) => res.json())
      .then((data) => {
        window.deliveryPincodeSLA = data;
      });

    // UTC-shifted-to-IST math keeps the customer's own browser timezone out of the cutoff comparison.
    function getIstNow() {
      const now = new Date();
      return new Date(now.getTime() + IST_OFFSET_MINUTES * 60000);
    }

    function getExpectedDeliveryDate(slaDays) {
      const istNow = getIstNow();
      const dispatchDelay = istNow.getUTCHours() < DISPATCH_CUTOFF_HOUR ? 0 : 1;

      return new Date(Date.UTC(
        istNow.getUTCFullYear(),
        istNow.getUTCMonth(),
        istNow.getUTCDate() + dispatchDelay + slaDays
      ));
    }

    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail?.variant || event.detail?.selectedVariant;
      const deliveryTextEl = document.querySelector('#delivery-date-text');

      if (!variant) {
        window.currentVariantAvailable = true;
        window.currentVariantInventory = null;
        window.currentVariantId = null;

        if (deliveryTextEl) {
          deliveryTextEl.classList.remove('active');
          deliveryTextEl.textContent = "";
        }
        return;
      }

      window.currentVariantAvailable = variant.available;
      window.currentVariantId = variant.id;

      updateShipMessage();

      if (window.lastCheckedPincode) {
        const input = document.getElementById('check-delivery-input');
        if (input && input.value.trim()) checkDelivery(false);
      }
    });


    function checkDelivery(showLoader = true) {
      const input = document.getElementById('check-delivery-input');
      const result = document.getElementById('check-delivery-result');
      const button = document.getElementById('check-delivery-btn');
      const buttonContent = button.querySelector('.check-delivery-btn-content');
      const buttonLoader = button.querySelector('.check-delivery-btn-loader');
      const pincode = input.value.trim();

      window.lastCheckedPincode = pincode;

      if (showLoader) {
        buttonContent.style.display = 'none';
        buttonLoader.style.display = 'flex';
        button.disabled = true;
      }

      const processDelivery = () => {
        if (showLoader) {
          buttonLoader.style.display = 'none';
          buttonContent.style.display = 'flex';
          button.disabled = false;
        }

        if (!/^\d{6}$/.test(pincode)) {
          result.textContent = 'Please enter a valid 6-digit pincode.';
          result.style.color = '#d32f2f';
          return;
        }

        const slaDays = window.deliveryPincodeSLA[pincode];
        if (slaDays === undefined) {
          result.textContent = 'Delivery date unavailable for this pincode. Please contact support to confirm delivery timelines.';
          result.style.color = '#d32f2f';
          return;
        }

        const expectedDate = getExpectedDeliveryDate(slaDays)
          .toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
        
        result.innerHTML = `
        <div style="display:flex;flex-direction:column;gap:10px;">
          <span style="display:inline-flex;align-items:center;gap:8px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M7.17904 2.73649C4.60171 2.73649 2.51237 4.82583 2.51237 7.40316C2.51237 9.98049 4.60171 12.0698 7.17904 12.0698C9.75636 12.0698 11.8457 9.98049 11.8457 7.40316C11.8457 4.82583 9.75636 2.73649 7.17904 2.73649ZM1.3457 7.40316C1.3457 4.1815 3.95738 1.56982 7.17904 1.56982C10.4007 1.56982 13.0124 4.1815 13.0124 7.40316C13.0124 10.6248 10.4007 13.2365 7.17904 13.2365C3.95738 13.2365 1.3457 10.6248 1.3457 7.40316ZM9.89991 5.50884C10.1407 5.72287 10.1624 6.09158 9.94836 6.33237L6.83725 9.83237C6.72655 9.9569 6.56788 10.0282 6.40126 10.0282C6.23464 10.0282 6.07597 9.9569 5.96527 9.83237L4.40971 8.08237C4.19568 7.84158 4.21737 7.47287 4.45816 7.25884C4.69895 7.0448 5.06766 7.06649 5.28169 7.30728L6.40126 8.56679L9.07638 5.55728C9.29042 5.31649 9.65913 5.2948 9.89991 5.50884Z" fill="#016E57"/>
            </svg>
            <span>Get it by ${expectedDate}</span>
          </span>
          <span style="display:inline-flex;align-items:center;gap:8px;">
           <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M7.17904 2.73649C4.60171 2.73649 2.51237 4.82583 2.51237 7.40316C2.51237 9.98049 4.60171 12.0698 7.17904 12.0698C9.75636 12.0698 11.8457 9.98049 11.8457 7.40316C11.8457 4.82583 9.75636 2.73649 7.17904 2.73649ZM1.3457 7.40316C1.3457 4.1815 3.95738 1.56982 7.17904 1.56982C10.4007 1.56982 13.0124 4.1815 13.0124 7.40316C13.0124 10.6248 10.4007 13.2365 7.17904 13.2365C3.95738 13.2365 1.3457 10.6248 1.3457 7.40316ZM9.89991 5.50884C10.1407 5.72287 10.1624 6.09158 9.94836 6.33237L6.83725 9.83237C6.72655 9.9569 6.56788 10.0282 6.40126 10.0282C6.23464 10.0282 6.07597 9.9569 5.96527 9.83237L4.40971 8.08237C4.19568 7.84158 4.21737 7.47287 4.45816 7.25884C4.69895 7.0448 5.06766 7.06649 5.28169 7.30728L6.40126 8.56679L9.07638 5.55728C9.29042 5.31649 9.65913 5.2948 9.89991 5.50884Z" fill="#016E57"/>
            </svg>
            <span>Cash on delivery available</span>
          </span>
          <span style="display:inline-flex;align-items:center;gap:8px;">
           <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M7.17904 2.73649C4.60171 2.73649 2.51237 4.82583 2.51237 7.40316C2.51237 9.98049 4.60171 12.0698 7.17904 12.0698C9.75636 12.0698 11.8457 9.98049 11.8457 7.40316C11.8457 4.82583 9.75636 2.73649 7.17904 2.73649ZM1.3457 7.40316C1.3457 4.1815 3.95738 1.56982 7.17904 1.56982C10.4007 1.56982 13.0124 4.1815 13.0124 7.40316C13.0124 10.6248 10.4007 13.2365 7.17904 13.2365C3.95738 13.2365 1.3457 10.6248 1.3457 7.40316ZM9.89991 5.50884C10.1407 5.72287 10.1624 6.09158 9.94836 6.33237L6.83725 9.83237C6.72655 9.9569 6.56788 10.0282 6.40126 10.0282C6.23464 10.0282 6.07597 9.9569 5.96527 9.83237L4.40971 8.08237C4.19568 7.84158 4.21737 7.47287 4.45816 7.25884C4.69895 7.0448 5.06766 7.06649 5.28169 7.30728L6.40126 8.56679L9.07638 5.55728C9.29042 5.31649 9.65913 5.2948 9.89991 5.50884Z" fill="#016E57"/>
            </svg>
            <span>Easy 15 days return & exchange available</span>
          </span>
        </div>`;
        result.style.color = '#231911';
      };

      // No network call happens here — this delay only makes the loading spinner perceptible on a user-initiated check.
      if (showLoader) setTimeout(processDelivery, 1000);
      else processDelivery();
    }

    function getProductJson() {
      if (cachedProductJson) return cachedProductJson;
      const productJsonEl = document.getElementById('product-json');
      if (!productJsonEl) return null;
      try {
        cachedProductJson = JSON.parse(productJsonEl.textContent);
      } catch (e) {
        console.error('Failed to parse product JSON', e);
        return null;
      }
      return cachedProductJson;
    }

    // Only reacts to a size the customer actually picked — no first-variant fallback, so nothing shows before a size is chosen.
    function updateShipMessage() {
      const deliveryTextEl = document.querySelector('#delivery-date-text');
      if (!deliveryTextEl) return;

      deliveryTextEl.classList.remove('active');
      deliveryTextEl.textContent = "";

      const productJson = getProductJson();
      if (!productJson || !window.currentVariantId) return;

      const variantData = productJson.variants.find(v => v.id == window.currentVariantId);
      if (!variantData) return;

      window.currentVariantInventory = variantData.inventory_quantity;

      // backorder = tracked + "Continue selling when out of stock" + no stock left (computed in Liquid).
      // oos_ship comes from the oos-ship-by snippet; if a cached page outlives its date, show nothing.
      const oosShip = variantData.oos_ship || {};
      const istToday = getIstNow().toISOString().slice(0, 10);
      const msg = oosShip.until && oosShip.until < istToday ? "" : oosShip.message || "";
      if (variantData.backorder && msg) {
        deliveryTextEl.textContent = msg;
        deliveryTextEl.classList.add('active');
      }
    }


    document.getElementById('check-delivery-btn').addEventListener('click', () => checkDelivery(true));
    document.getElementById('check-delivery-input').addEventListener('keydown', (e) => {
      if (e.key === 'Enter') checkDelivery(true);
    });
    document.getElementById('check-delivery-input').addEventListener('input', () => {
      document.getElementById('check-delivery-result').textContent = '';
      window.lastCheckedPincode = null;
    });
    updateShipMessage();
  });